<template>
  <a-row :gutter="8" :class="getScreen ? 'm-list-wrapper' : 'd-list-wrapper'">
    <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
      <a-card>
        <div slot="title">
          <a-icon class="margin-right" type="file-search" />Search
        </div>
        <ul class="m-list-wrapper">
          <li>
            <a-input-search v-model="search" placeholder="Quick Search" />
          </li>
          <li>
            <a-collapse :activeKey="getScreen ? 0 : 1">
              <a-collapse-panel key="1">
                <span slot="header">Search More...</span>
                <div class="m-form-item-wrapper">
                  <label>Transaction Date</label>
                  <a-range-picker :placeholder="['Start Date', 'End Date']" v-model="transactionDt"
                    :format="dateFormat" />
                </div>
                <div class="m-form-item-wrapper">
                  <label>Category</label>
                  <a-select placeholder="Ex: Value's < 50 Million Rupiah" v-model="kategori" class="width-full"
                    initialValue="null" allowClear>
                    <a-select-option value="less">Value's &#60; 50 Million Rupiah</a-select-option>
                    <a-select-option value="over">Value's &#62;= 50 Million Rupiah</a-select-option>
                  </a-select>
                </div>
                <div class="m-form-item-wrapper">
                  <label>WorkFlow Status</label>
                  <a-select placeholder="Ex: Not Closed... " v-model="statusWorflow" class="width-full"
                    initialValue="Not Closed" allowClear>
                    <a-select-option value="Opened">Not Closed</a-select-option>
                    <a-select-option value="Closed">Closed</a-select-option>
                  </a-select>
                </div>
                <div class="m-form-item-wrapper">
                  <label>Transaction Status</label>
                  <a-select placeholder="Ex: Approved ... " v-model="status" class="width-full" initialValue="delivered"
                    allowClear>
                    <a-select-option value="delivered">Delivered</a-select-option>
                    <a-select-option value="approved">Approved</a-select-option>
                    <a-select-option value="on process">On Process</a-select-option>
                    <a-select-option value="revised">Revised</a-select-option>
                    <a-select-option value="rejected">Rejected</a-select-option>
                    <a-select-option value="transferred">Transferred</a-select-option>
                  </a-select>
                </div>
              </a-collapse-panel>
            </a-collapse>
          </li>
        </ul>
      </a-card>
    </a-col>
    <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
      <DataList :loading="loading" title="UM PP List" :manifestLink="getManifestLink" :dataList="searching"
        :disabledCreateEditLink="true" :isMonitoring="true" />
    </a-col>
  </a-row>
</template>


<script>
import axios from "axios";
import { mapGetters } from "vuex";
import moment from "moment";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import _ from "lodash";

export default {
  name: "ListUmPp",
  mixins: [CurrencyFormat],
  props: ["prnMenu"],
  data() {
    return {
      loading: true,
      dateFormat: "DD MMM YYYY",
      umList: [],
      search: "",
      tempList: "",
      kategori: undefined,
      statusWorflow: undefined,
      status: undefined,
      transactionDt: [],
      form: this.$form.createForm(this),
      pagination: {
        onChange: (page) => {
          console.log(page);
        },
        pageSize: 5,
        size: "small",
      },
    };
  },
  mounted() {
    this.fetchData();
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getDefaultDateFormat",
      "getStandartFormatDate",
    ]),
    searching: {
      get: function () {
        let self = this;
        let outputData = this.umList;

        if (this.search) {
          outputData = outputData.filter(
            (obj) =>
              obj.search.toLowerCase().indexOf(this.search.toLowerCase()) >=
              0 ||
              (obj.realisasi &&
                this.formatCurrency(obj.currency, obj.realisasi)
                  .toString()
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0) ||
              obj.subtitle.deskripsi
                .toLowerCase()
                .indexOf(this.search.toLowerCase()) >= 0 ||
              obj.status.toLowerCase().indexOf(this.search.toLowerCase()) >= 0
          );
        }

        if (this.kategori) {
          outputData = outputData.filter((item) => {
            return this.kategori == "less" ? item.realisasirp < 50000000 : item.realisasirp >= 50000000;
          });
        }

        if (this.statusWorflow) {
          outputData = _.filter(outputData, (item) => {
            return (
              item.endStatus.toLowerCase() == self.statusWorflow.toLowerCase()
            );
          });
        }

        if (this.status) {
          outputData = _.filter(outputData, (item) => {
            return item.status.toLowerCase() == self.status.toLowerCase();
          });
        }

        if (self.transactionDt.length > 0) {
          let startDt = moment(self.transactionDt[0]).format(
            this.getStandartFormatDate
          );
          let endDt = moment(self.transactionDt[1]).format(
            this.getStandartFormatDate
          );

          outputData = _.filter(outputData, (obj) => {
            return obj.createDate >= startDt && obj.createDate <= endDt;
          });
        }

        return outputData;
      },
    },

    getManifestLink() {
      if (localStorage.getItem("nvpn") === "/keuangan") {
        return "SpclUMPPManifestKeu";
      } else if (localStorage.getItem("nvpn") === "/pimpro") {
        return "SpclUMPPManifestPimpro";
      } else if (localStorage.getItem("nvpn") === "/atasanLangsung") {
        return "SpclUMPPManifestAL";
      } else if (localStorage.getItem("nvpn") === "/direktur") {
        return "SpclUMPPManifestDir";
      } else if (localStorage.getItem("nvpn") === "/akuntansiKeuangan") {
        return "SpclUMPPManifestAcc";
      } else if (localStorage.getItem("nvpn") === "/vpf") {
        return "SpclUMPPManifestVpf";
      } else if (localStorage.getItem("nvpn") === "/FinancialControl") {
        return "SpclUMPPManifestFin";
      } else if (localStorage.getItem("nvpn") === "/ga") {
        return "SpclUMPPManifestGA";
      } else {
        return "SpclUMPPManifest_";
      }
    },
  },
  methods: {
    moment,
    fetchData() {
      axios({
        method: "get",
        url: this.$serviceUrl + "monitoring/um_pp",
        params: {
          id: localStorage.getItem("nvky"),
          tlc: this.getAuth.username,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          response.data.data.forEach((data) => {
            const date = this.moment(data.tgl_buat).format(
              this.getDefaultDateFormat
            );
            this.umList.push({
              title: data.no_um,
              subtitle: { deskripsi: data.deskripsi },
              subdesc: [
                [
                  {
                    label: date,
                    value: "",
                  },
                ],
                [
                  {
                    label: "Estimated value",
                    value: this.formatCurrency(data.currency, data.value_um),
                  },
                ],
                [
                  {
                    label: "Realization value",
                    value:
                      data.realisasi == "0"
                        ? "There are no reports yet"
                        : this.formatCurrency(data.currency, data.realisasi),
                  },
                ],
              ],
              search: data.no_um + " " + data.tgl_buat + " " + data.value_um,
              createDate: data.tgl_buat,
              valueUm: data.value_um,
              realisasi: data.realisasi,
              realisasirp: data.realisasirp,
              status: data.status,
              timeline: JSON.parse(data.status_app),
              unread: data.unread == "1" ? true : false,
              endStatus: data.isclosed,
              peruntukan: data.peruntukan,
              id: data.id_um,
            });
          });

          this.loading = false;
        })
        .catch((err) => {
          if (!err.response) {
            this.displayMessage("error-connection-refused");
          } else {
            this.loading = false;
            this.displayMessage("empty-db");
          }
        });
    },
  },
};
</script>